export default __webpack_public_path__ + "static/media/services_styling.9ade2a4e.jpg";